export default {
    'Change orientation': "Changement d'orientation",
}